// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ad6d0001","703":"a153cb86","787":"a72690cc"}[chunkId] + ".chunk.js";
};